import { useSelector } from 'react-redux';
import { RootState } from '../healthcheck/appReducer';
import FeatureFlagHealthcheckI from './FeatureFlagHealthcheckI';

const useFeatureFlagsHealthcheck = (): FeatureFlagHealthcheckI => {
  const featureFlags = useSelector((state: RootState) => state.featureFlag);

  return featureFlags;
};

export default useFeatureFlagsHealthcheck;
